import Button from 'atoms/button';
import { ESTABLISHMENT_CLICKOUT_SECTIONS } from 'templates/establishment/constants';
import PropTypes from 'prop-types';
import React from 'react';
import Tooltip from 'atoms/tooltip';


export default function PartnerInfoButton({
  className, countryCode, handleEvents, hasCancellationPolicy, instantBook, isAlone, isBestPrice,
  numberFormat, partner, partnersWithMultiLogo, partnersWithoutAvailabilityClickout, t,
}) {
  const canUseCancellationPolicy = partner.cancellationPolicy && Object.keys(partner.cancellationPolicy).length !== 0 && hasCancellationPolicy;
  const partnerCancellationPolicy = canUseCancellationPolicy ? { days: Object.values(partner.cancellationPolicy)[0] } : null;

  const classImage = Object.keys(partnersWithMultiLogo).includes(String(partner.id))
    && partnersWithMultiLogo[partner.id].includes(countryCode)
    ? `partner-info-button__left-section__top__logo-${partner.id}__img__${countryCode}`
    : `partner-info-button__left-section__top__logo-${partner.id}__img`;


  return (
    isBestPrice
      ? (
        <div className={ `partner-info-button -best-price ${className}` }>
          <div
            className="partner-info-button__left-section"
            onClick={ handleEvents.bind(null, partner, ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_BEST_PRICE) }
          >
            <div className={ `partner-info-button__left-section__top ${isAlone ? '' : '-not-alone'}` }>
              <span className={ `partner-info-button__left-section__top__logo-${partner.id}` }>
                <img
                  alt={ `${partner.visibleName} logo` }
                  className={ classImage }
                  src="/img/partner-logos/sprite-logos.png"
                />
              </span>
            </div>
            <div className="partner-info-button__left-section__options">
              { !isAlone
                && (
                  <div className="partner-info-button__left-section__options__bottom">
                    { t("Best price") }
                  </div>
                )
              }
              { canUseCancellationPolicy
                ? (hasCancellationPolicy.has100PercentCancellationPolicy
                  ? (
                    <Tooltip
                      baseClassName="partner-info-button__tooltip"
                      position="bottom"
                      space={ 0 }
                      title={ (partnerCancellationPolicy.days === 0)
                        ? t("Holiday rental with free cancellation until the day of your arrival.")
                        : t("Holiday rental with free cancellation up to {cancellationPolicyDays} days before your arrival.", { cancellationPolicyDays: partner.cancellationPolicy['100'] })
                      }
                      tooltipX={ 50 }
                    >
                      <span className="hundredicons-cancellation-simple -full" />
                    </Tooltip>
                  ) : (
                    <Tooltip
                      baseClassName="partner-info-button__tooltip"
                      position="bottom"
                      space={ 0 }
                      title={
                        (partnerCancellationPolicy.days === 0)
                          ? t("This holiday rental is partially refundable up to the check-in date.")
                          : t("This holiday rental is partially refundable up to {cancellationPolicyDays} days before the check-in date.", { cancellationPolicyDays: partnerCancellationPolicy.days })
                      }
                      tooltipX={ 50 }
                    >
                      <span className="hundredicons-cancellation-simple -partial" />
                    </Tooltip>
                  )
                ) : null
              }
              { !instantBook ? null
                : (
                  <Tooltip
                    baseClassName="partner-info-button__tooltip"
                    position="bottom"
                    space={ 0 }
                    title={ t("Book your holiday rental without waiting for the host's approval") }
                    tooltipX={ 75 }
                  >
                    <span className="partner-info-button__left-section__options__icon hundredicons-bolt-filled" />
                  </Tooltip>
                )
              }
            </div>
          </div>
          <div
            className="partner-info-button__middle-section"
            onClick={ handleEvents.bind(null, partner, ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_PRICE_WINNER) }
          >
            <div className="partner-info-button__middle-section__prices">
              <div className="partner-info-button__middle-section__prices__top">
                <div className="partner-info-button__middle-section__prices__top__price">
                  { t("{price}£", { price: numberFormat(partner.pricePerNight) }) }
                </div>
                <span className="partner-info-button__middle-section__prices__top__night">
                  { `/ ${t("night")}` }
                </span>
              </div>
              <div className="partner-info-button__middle-section__prices__bottom">
                { t("{mtp}£ in total", { mtp: numberFormat(partner.priceTotal) }) }
              </div>
            </div>
          </div>
          <div className="partner-info-button__right-section">
            <div className="partner-info-button__right-section__button-container">
              <Button
                className="partner-info-button__right-section__button-container__button"
                handleOnClick={ handleEvents.bind(null, partner, ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_CTA) }
              >
                <span className="partner-info-button__right-section__button-container__button__text">
                  { t("View offer") }
                </span>
                <div className="partner-info-button__right-section__button-container__button__prices">
                  <div className="partner-info-button__right-section__button-container__button__prices__price">
                    { t("{price}£", { price: numberFormat(partner.pricePerNight) }) }
                  </div>
                  <span className="partner-info-button__right-section__button-container__button__prices__night">
                    { `/ ${t("night")}` }
                  </span>
                </div>
              </Button>
            </div>
            <div className="partner-info-button__right-section__total">
              { t("{mtp}£ in total", { mtp: numberFormat(partner.priceTotal) }) }
            </div>
          </div>
        </div>
      ) : (
        !(!partner.pricePerNight && !partner.priceTotal && partnersWithoutAvailabilityClickout.includes(partner.id)) && (
          <div className={ `partner-info-button ${className}` }>
            <div className="partner-info-button__left-section">
              <div className="partner-info-button__left-section__top">
                <span className={ `partner-info-button__left-section__top__logo-${partner.id}` }>
                  <img
                    alt={ `${partner.visibleName} logo` }
                    className={ classImage }
                    onClick={ handleEvents.bind(null, partner, ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_PARTNER_LOGO) }
                    src="/img/partner-logos/sprite-logos.png"
                  />
                </span>
              </div>
              <div className="partner-info-button__left-section__options">
                { canUseCancellationPolicy
                  ? (hasCancellationPolicy.has100PercentCancellationPolicy
                    ? (
                      <Tooltip
                        baseClassName="partner-info-button__tooltip"
                        position="bottom"
                        space={ 0 }
                        title={
                          (partnerCancellationPolicy.days === 0)
                            ? t("Holiday rental with free cancellation until the day of your arrival.")
                            : t("Holiday rental with free cancellation up to {cancellationPolicyDays} days before your arrival.", { cancellationPolicyDays: partner.cancellationPolicy['100'] })
                        }
                        tooltipX={ 50 }
                      >
                        <span className="hundredicons-cancellation-simple -full" />
                      </Tooltip>
                    ) : (
                      <Tooltip
                        baseClassName="partner-info-button__tooltip"
                        position="bottom"
                        space={ 0 }
                        title={
                          (partnerCancellationPolicy.days === 0)
                            ? t("This holiday rental is partially refundable up to the check-in date.")
                            : t("This holiday rental is partially refundable up to {cancellationPolicyDays} days before the check-in date.", { cancellationPolicyDays: partnerCancellationPolicy.days })
                        }
                        tooltipX={ 50 }
                      >
                        <span className="hundredicons-cancellation-simple -partial" />
                      </Tooltip>
                    )
                  ) : null
                }
                { !instantBook ? null
                  : (
                    <Tooltip
                      baseClassName="partner-info-button__tooltip"
                      position="bottom"
                      space={ 0 }
                      title={ t("Book your holiday rental without waiting for the host's approval") }
                      tooltipX={ 75 }
                    >
                      <span className="partner-info-button__left-section__options__icon hundredicons-bolt-filled" />
                    </Tooltip>
                  )
                }
              </div>
            </div>
            { partner.pricePerNight && partner.priceTotal
              && (
                <div
                  className="partner-info-button__middle-section"
                  onClick={ handleEvents.bind(null, partner, ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_PRICE_OTHER) }
                >
                  <div className="partner-info-button__middle-section__prices">
                    <div className="partner-info-button__middle-section__prices__top">
                      <div className="partner-info-button__middle-section__prices__top__price">
                        { t("{price}£", { price: numberFormat(partner.pricePerNight) }) }
                      </div>
                      <span className="partner-info-button__middle-section__prices__top__night">
                        { `/ ${t("night")}` }
                      </span>
                    </div>
                    <div className="partner-info-button__middle-section__prices__bottom">
                      { t("{mtp}£ in total", { mtp: numberFormat(partner.priceTotal) }) }
                    </div>
                  </div>
                </div>
              )
            }
            <div className="partner-info-button__right-section">
              <div
                className="partner-info-button__right-section__button-container"
                onClick={ handleEvents.bind(null, partner, ESTABLISHMENT_CLICKOUT_SECTIONS.ESTABLISHMENT_MATCHING) }
              >
                <div className="partner-info-button__right-section__button-container__link">
                  { partner.pricePerNight && partner.priceTotal
                    ? (
                      <div>
                        <div className="partner-info-button__right-section__button-container__link__prices">
                          <div className="partner-info-button__right-section__button-container__link__prices__price">
                            { t("{price}£", { price: numberFormat(partner.pricePerNight) }) }
                          </div>
                          <span className="partner-info-button__right-section__button-container__link__prices__night">
                            { `/ ${t("night")}` }
                          </span>
                        </div>
                        <span className="partner-info-button__right-section__button-container__link__text">
                          { t("View offer") }
                        </span>
                      </div>
                    ) : t("Check")
                  }
                  <span className="hundredicons-arrow-right-filled" />
                </div>
                { partner.pricePerNight && partner.priceTotal
                  && (
                    <div className="partner-info-button__right-section__button-container__total">
                      { t("{mtp}£ in total", { mtp: numberFormat(partner.priceTotal) }) }
                    </div>
                  )
                }
              </div>
            </div>
          </div>
        )
      )
  );
}

PartnerInfoButton.defaultProps = {
  className: '',
  countryCode: null,
  handleEvents: () => {},
  isAlone: true,
  isBestPrice: false,
  numberFormat: n => n,
  partner: {},
  partnersWithMultiLogo: {},
  partnersWithoutAvailabilityClickout: [],
};

PartnerInfoButton.propTypes = {
  className: PropTypes.string,
  countryCode: PropTypes.string,
  handleEvents: PropTypes.func,
  hasCancellationPolicy: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
  instantBook: PropTypes.bool.isRequired,
  isAlone: PropTypes.bool,
  isBestPrice: PropTypes.bool,
  numberFormat: PropTypes.func,
  partner: PropTypes.shape({
    clickoutLink: PropTypes.string,
    favicon: PropTypes.string,
    id: PropTypes.number,
    instantlyBooking: PropTypes.bool,
    pricePerNight: PropTypes.number,
    priceTotal: PropTypes.number,
    visibleName: PropTypes.string,
  }),
  partnersWithMultiLogo: PropTypes.shape(),
  partnersWithoutAvailabilityClickout: PropTypes.arrayOf(PropTypes.number),
  t: PropTypes.func.isRequired,
};
